export const MAIN_SITE_URL = 'https://polyswarm.io';
export const PORTAL_URL = 'https://polyswarm.network';
